import axios from "./../../http/axios";
import {
  GET_FINANCICAL_SCHEMAS,
  SET_FINANCICAL_SCHEMAS_TEMPLATES,
  GET_FINANCICAL_SCHEMAS_TEMPLATES,
  ADD_WATERFALL_SCHEMAS,
  GET_FINANCICAL_SCHEMA_BY_ID,
  EDIT_WATERFALL_SCHEMAS,
  DELETE_WATERFALL_SCHEMAS,
  EMPTY_FIN_STRUCTURE,
  NEM_FIN_STR_CREATING_STATUS,
  SET_DEALROOM_FIN_ERRORS,
  SET_DEALROOM_FIN_ERRORS_OBJ_CREATING,
  token, SET_FIN_ERROR, EMPTY_FIN_ERROR, SET_FIN_ERRORS_NULL
} from "./types";


export const getFinancicalSchemas = archive => dispatch => {
  const url = `user-schemas/UserFinancialStructures/${
    archive ? "?archived=1" : ""
  }`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_FINANCICAL_SCHEMAS,
        payload: {res:res.data,showIcon: archive ? false : true}});
    });
};

export const getFinancicalSchemaById = id => dispatch => {
  const url = `/user-schemas/UserFinancialStructures/${id}/`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_FINANCICAL_SCHEMA_BY_ID,
        payload: res.data
      });
    });
};

export const addWaterfallSchemas = data => async dispatch => {
  const url = "/user-schemas/UserFinancialStructures/";
  return await axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: ADD_WATERFALL_SCHEMAS,
        payload: res.data
      });
    });
};

export const editWaterfallSchemas = (data, id) => async dispatch => {
  const url = `/user-schemas/UserFinancialStructures/${id}/`;
  return await axios
    .put(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: EDIT_WATERFALL_SCHEMAS,
        payload: res.data
      });
    });
};

export const emptyEditFinStructure = () => dispatch => {
  return dispatch({
    type: EMPTY_FIN_STRUCTURE,
  });
};

export const deleteWaterfallSchemas = id =>  dispatch => {
  const url = `/user-schemas/UserFinancialStructures/${id}/`;
  return  axios
    .delete(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: DELETE_WATERFALL_SCHEMAS,
        payload: res,
        id
      });
    });
};

export const getFinancicalSchemasTemplate = () => dispatch => {
  const url = "/schemas/waterfallItem-model/?archived=";
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_FINANCICAL_SCHEMAS_TEMPLATES,
        payload: res.data
      });
    });
};

export const setFinancalSchemasTemplates = data => async dispatch => {
  const url = "user-schemas/checked-waterfall-items/";
  return await axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: SET_FINANCICAL_SCHEMAS_TEMPLATES,
        payload: res.data
      });
    });
};

export const setFinSchemaError = (error, field) => dispatch => {

  return dispatch({
    type: SET_FIN_ERROR,
    payload: {error, field}
  });
};

export const setDealRoomFinSchemaErrors = (error, field,index) => dispatch => {

  return dispatch({
    type: SET_DEALROOM_FIN_ERRORS,
    payload: {error, field,index}
  });
};
export const setDealRoomFinSchemaErrorsObjectsCreating = (count) => dispatch => {

  return dispatch({
    type: SET_DEALROOM_FIN_ERRORS_OBJ_CREATING,
    payload: count
  });
};

export const newFinStrCreatingStatus = (bool) => dispatch => {
  return dispatch({type:NEM_FIN_STR_CREATING_STATUS,payload:bool})
};

export const emptyFinStrErrors = () => dispatch =>{
  return dispatch({
    type: EMPTY_FIN_ERROR,
  });
};
export const setFinStrErrorsNull = () => dispatch =>{
  return dispatch({
    type: SET_FIN_ERRORS_NULL,
  });
};


// WEBPACK FOOTER //
// ./src/store/actions/financicalSchemas.js